import SuccessMessage from "@/components/SuccessMessage/SuccessMessage.vue"
import store from "../../store";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            message: `Payment is successful. Your plan will be activated within 2 minutes. 
            If your plan hasn’t changed, please contact our <a href="/support">support</a>`
        }
    },
    components: {
        SuccessMessage
    },
    computed: {
        ...mapGetters([
            'isLoggedIn'
        ])
    },
    methods: {
        // update_after_pay() {
        //     this.$store.dispatch('update_info_subscription_after_pay').then()
        // }
    },
    created() {
        // this.update_after_pay()
    }
}
